<template>
  <div id="seal">
    <!-- <h3>破产案例</h3> -->
    <el-card class="index" v-if="$route.name!='Bidinput'&&$route.name!='bankinput'">
      <div class="menu">
        <el-menu :default-active="$route.name" :key="key" class="el-menu-demo" mode="horizontal" @select="SelectMenu"
          >
          <!-- <el-menu-item index="bankrupt">破产案例</el-menu-item> -->
          <el-menu-item v-for="(item, index) in targetRoutes" :key="index" :index="item.path">
            {{ item.meta.title }}
          </el-menu-item>
        </el-menu>
      </div>
      <!-- <el-button type="success" @click="enter('case')" v-if="$route.name=='bankruptCase'" class="btn">案件录入</el-button> -->
      <el-button type="success" @click="enter('Bid')" v-if="($route.name=='bankruptBid'||$route.name=='allbankruptBid')&&$store.state.rolesname.includes('Bidinput')"  class="btn">投标录入</el-button>
      <!-- 折腾跳转是出现的文字 -->
      <div class="kb"></div>
      <div class="xian"></div>
      <router-view @value="getvalue"></router-view>

    </el-card>
    <router-view v-else @value="getvalue"></router-view>
    
  </div>
</template>
  
<script>
import {changerouter } from "../../utils/seal.js";
export default {
  name: "seal",
  data() {
    return {
      next: false,
      active: "",
    };
  },
  methods: {
    SelectMenu(item) {
       console.log('hahahhaha')
      this.$store.commit('setPage', 1)
      this.$router.push({
        query: {
          guid: this.$route.query.guid,
          type:this.$route.query.type
                },
        path:item,
      });
    },
    getvalue(value) {//获取子组件的值
      this.next = value;
      // console.log("成功"+value);
    },
    enter(type) {
      let that = this;
      if (type == 'case') {
        that.$router.push({
          path: 'bankinput'
        });
      } else if (type == "Bid") {
        that.$router.push({
          path: 'Bidinput'
        });
      }


    },
  },
  created() {
  },
  computed: {
    key() {
      if (this.$route.meta.menu == "Sealdetail") {
        return "Sealdetail"
      } else if (this.$route.meta.menu == "Biddetail") {
        return "Biddetail"
      }
      else if (this.next) {
        return "sealApply"
      }
    },
    targetRoutes() {
        let target = this.$store.state.permission.addRoutes.filter(
          el => el.path == "/home/bankrupt"//遍历每一个数组，过滤出返回值委true的值
        );
        // console.log(target)
        let arr=target[0].children
       if(this.next){
          arr = arr.filter(
            el=>el.hidden==true&&el.meta.menu=='detail'
        )}else{
          arr = arr.filter(
            el=>el.hidden!=true
          )
        }
       
        // console.log(arr)
        return arr;
      }
    


  },
  watch: {
  }
};
</script>
  
<style lang="less" scoped>
#seal .index {
  width: 100%;
  margin: auto;
  border-radius: 16px;
  position: relative;
 
}

#seal .el-menu {
  display: flex;
  text-align: center;
  border-right: 0px;
  // margin-bottom: 5vh;
  // .el-menu-item{
  //   width:20vh;
  // }

  .el-menu-item {
    font-size: 16px;
    height: 55px;

    &:hover {
      background-color: #fff;
      color: #409eff !important;
      border-bottom: 1px solid #409eff;
    }
  }

  .el-menu-item.is-active {
    background-color: #fff !important;
    border-bottom: 1px solid #409eff;
    color: #409eff !important;
  }
}

#seal .el-menu.el-menu--horizontal {
  border-bottom: none;
}

#seal .menu {
  width: 96%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#seal /deep/.el-card__body,
#seal .el-main {
  padding: 0px;
  padding-bottom: 20px;

}

#seal .xian {
  width: 100%;
  border-bottom: 1px solid rgba(238, 239, 242, 1);
  margin-bottom: 24px;

}

#seal .btn {
  position: absolute;
  top: 8px;
  right: 2%;
  z-index: 2;
  // position:absolute;
  // top:130px;
  // right: 2%;
}

#seal .kb {
  width: 98px;
  height: 48px;
  position: absolute;
  top: 8px;
  right: 2%;
  background: #fff;
  z-index: 1;
}</style>
  